import {
  Query_DailyReports_OptionsInput,
  useDailyReportTableQuery
} from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  description: string;
  date: DateTime;
  approvedAt: DateTime | null;
  approvedBy: string;
  phoneNumber: string;
  eventCount: {
    inspections: number;
    incidents: number;
    deliveries: number;
    events: number;
  };
}

export function useQuery(options: Query_DailyReports_OptionsInput) {
  const tuple = useDailyReportTableQuery({
    variables: {
      options
    },
    skip: options.filter?.projectId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.dailyReports.map((node) => ({
        id: node.id,
        approvedAt: node.approvedAt ?? null,
        approvedBy: node.approvedBy?.fullName ?? '',
        description: node.description,
        phoneNumber: node.approvedBy?.phoneNumber ?? '',
        date: node.reportDate,
        eventCount: {
          incidents: node.numberOfIncidents ?? 0,
          inspections: node.numberOfInspections ?? 0,
          deliveries: node.numberOfDeliveries ?? 0,
          events: node.numberOfWorkEvents ?? 0
        }
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
